<template>
  <div>
    <slot v-if="$store.state.space"></slot>
    <Placeholder v-else-if="loading" />
    <div v-else class="text-left lg:w-2/6 md:w-3/6 mx-auto ui form">
      <div class="ui form">
        <h3 class="mt-4 ui header text-center">访问加密数据</h3>
        <hr>
        <div class="my-8">
          请输入加密密钥来访问数据
        </div>
        <div class="field">
          <div class="ui fluid input"></div>
          <input autofocus id="passphrase" type="password" v-model="passphrase"
                 @keyup.enter="open_space"/>
        </div>
        <button class="ui teal fluid button" @click="open_space">进入</button>
        <div class="text-right mt-2">
          <small>
            <a class="cursor-pointer" @click="show_modal('passphrase-reset')">
              使用恢复码重置密钥
            </a>
          </small>
        </div>
      </div>
      <Modal id="passphrase-reset" size="mini" ok-titl="确认" cancle-title="取消" @ok="passphrase_reset">
        <h3 class="ui header text-center">
          修改密钥
        </h3>
        <div class="ui form">
          <div class="field">
            <label>恢复码:</label>
            <input name="rec-code" id="rec-code" type="password" v-model="recovery_code">
          </div>
          <div class="field">
            <label>新密钥:</label>
            <input id="new-pass" name="new-pass" type="password" v-model="new_passphrase">
          </div>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import Placeholder from './placeholder.vue';
import Modal from './modal.vue';

export default {
  name: 'SpaceOpener',
  props: [],
  components: {
    Placeholder,
    Modal,
  },
  data: function () {
    return {
      loading: true,
      passphrase: this.$store.state.default_passphrase,
      new_passphrase: '',
      recovery_code: '',
    };
  },
  computed: {
  },
  methods: {
    async passphrase_reset(e) {
      e.preventDefault();
      if (!this.new_passphrase) {
        this.show_error("新的密钥不能为空");
        return;
      }
      if (!this.recovery_code) {
        this.show_error("恢复码无效");
        return;
      }
      try {
        await this.client.reset_passphrase('', this.recovery_code, this.new_passphrase);
        this.show_success("重置密钥成功！");
        this.hide_modal('passphrase-reset');
      } catch (e) {
        this.show_error("重置密钥失败：" + e.message);
        return;
      }
    },
    async open_space(show_error=true) {
      if (!this.passphrase) {
        this.show_error("请输入密钥");
        return;
      }
      this.loading = true;
      try {
        var space = await this.client.open_space(this.$store.state.space_name, this.passphrase);
        await this.$store.dispatch('favs_init', space);
        this.$store.commit('set_space', { space: space, passphrase: this.passphrase });
        this.$store.commit('set_default_passphrase', this.passphrase);
      } catch (e) {
        if (e.message == 'EKEYREJECTED') {
          if (show_error) {
            this.show_error("密钥无效");
          }
        }
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    if (this.$store.state.space) {
      return;
    }
    await this.client.fetch_userinfo();
    if (!this.client.plan) {
      await this.$store.dispatch('refresh_userinfo');
      if (!this.client.plan) {
        this.$router.push({ name: 'buy' });
        return;
      }
    }
    if (!this.client.spaces.length) {
      await this.client.fetch_spaces();
    }
    if (this.client.spaces.length == 0) {
      this.$router.push({ name: 'welcome' });
    }
    if (this.passphrase) {
      this.open_space(false).then(() => {
        this.passphrase = '';
      });
    } else {
      this.loading = false;
    }
  },
}
</script>

<style scoped>
</style>
